
<div class="board-overview">
  <form v-on:submit.prevent="submitSearch">
    <div class="d-flex justify-content-start">
      <div>
        <div class="label">Date</div>
        <board-item-date-picker v-model="searchDateRange" :customClass="'boardOverview'" :columns="2" :is-range="true" :mode="'date'" />
      </div>

      <div class="search-items ml-2 d-flex">
        <div class="input-group">
          <input
            v-debounce="submitSearch"
            type="text"
            class="form-control input-sm"
            style="height: 30px"
            placeholder="Search..."
            v-model="search"
          />
          <div class="input-group-append" @click="submitSearch">
            <i class="fa fa-search input-group-text"></i>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column ml-4">
        <div class="label">Filter</div>
        <!-- Board items Filter -->
        <div>
          <div class="badgebutton" :class="selectedCategories.length === 0 ? 'active' : ''" @click="chooseCategory('all')">All</div>
          <div
            class="badgebutton ml-2"
            :class="selectedCategories.indexOf(category.id) !== -1 ? 'active' : ''"
            v-for="category in availableCategories"
            :key="category.id"
            @click="chooseCategory(category.id)"
          >
            {{ category.name }}
          </div>
        </div>
      </div>

      <div class="ml-4">
        <div class="label">Labels</div>
        <div class="mr-2 align-self-center">
          <div class="d-flex justify-content-left">
            <div v-for="label in selectedLabels" :key="label.id">
              <div
                class="mr-2 d-flex justify-content-between align-items-center"
                :style="{
                  'background-color': label.color,
                  color: 'white',
                  padding: '4px 5px',
                  'border-radius': '3px',
                  'font-size': '.9rem',
                }"
              >
                <i v-if="label.icon" :class="label.icon" class="mr-1 ml-1"></i>
                {{ label.title }}
                <div>
                  <i class="ml-2 fas fa-times cursor-pointer" @click="removeLabel(label)"></i>
                </div>
              </div>
            </div>

            <add-labels-filter @labeladded="addLabel"></add-labels-filter>
          </div>
        </div>


      </div>
    </div>
  </form>

  <div class="board-items mt-3" v-if="filteredItems && filteredItems.length">
    <table class="table table-striped fixed-header">
      <thead>
        <tr>
          <th scope="col">Category & Type</th>
          <th scope="col">Title & Description</th>
          <th scope="col">Labels</th>
          <th scope="col">Attachments</th>
          <th scope="col">Comments</th>
          <th scope="col">Subtasks</th>
          <th scope="col">Activity Date</th>
          <th scope="col">Status</th>
        </tr>
      </thead>
      <tbody>
        <board-item-overview
          :item="item"
          v-for="(item, index) in filteredItems"
          :key="index"
          :action="navigateToBoardItem"
          :action-param="item.id"
        ></board-item-overview>
      </tbody>
    </table>
  </div>

  <div v-if="!filteredItems || !filteredItems.length" class="p-12">
    <div class="label justify-content-center d-flex align-items-center">
      <i class="far fa-search fa-2x mr-2"></i>
      No Board items found, please modify your search</div>
  </div>

  <div v-if="loading" class="d-flex align-items-center justify-content-center p-5">
    <loading-spinner v-if="loading"></loading-spinner>
  </div>

  <router-view />
</div>
